import device from "current-device";

const footer = () => {
    const footer = document.querySelector(".footer-main");
    const footerCta = document.querySelector(".footer-cta");

    footer && footerInit(footer);
    footerCta && footerCtaInit(footerCta);

    function footerInit(el) {
        const footerText = el.querySelector(".footer-main__text");

        // Create a new Intersection Observer
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Add event listener
                    window.addEventListener("mousemove", handleMouseMove);
                } else {
                    // Remove event listener
                    window.removeEventListener("mousemove", handleMouseMove);
                }
            });
        });

        // Event handler function for mousemove event
        const handleMouseMove = event => {
            footerText.style.setProperty("--x", `${event.clientX}`);
            footerText.style.setProperty("--y", `${event.clientY}`);
        };

        // Start observing the footer text
        if (device.type === "desktop") {
            footer.classList.add("initiated");
            observer.observe(footerText);
        }
    }

    function footerCtaInit(el) {
        let isActive = false;
        const form = el.querySelector(".footer-cta__form");
        const back = el.querySelector(".footer-cta__back");

        const cards = el.querySelectorAll(".footer-cta__person");
        const cardButtons = el.querySelectorAll(".card-talkto__trigger");

        back.addEventListener("click", setInactive);
        cardButtons.forEach(button => {
            button.addEventListener("click", setActive);
        });

        function resetCards() {
            cards.forEach(card => {
                card.dataset.active = false;
            });
        }

        function setInactive() {
            // Mark the CTA as inactive
            isActive = false;
            el.dataset.active = isActive;

            resetCards();
        }
        function setActive(e) {
            // Mark the CTA as active
            isActive = true;
            el.dataset.active = isActive;

            resetCards();

            // Set this card active
            e.target.closest(".footer-cta__person").dataset.active = true;

            // Set the name in the form
            document.querySelector(".form-talkto__name").innerText = e.target.dataset.name;

            // Set the form action based on the clicked on card
            form.setAttribute("action", e.target.dataset.action);

            // Set the name on the inserted title
            document.querySelector(".footer-cta__inserted .name").innerText = e.target.dataset.name;
        }
    }
};

export default footer;
